export default "__VITE_ASSET__CP3$HYbi__"